import { useState, useEffect } from 'react';

function useDelayedTransition(initialValue, endValue, delayMs) {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    const timer = setTimeout(() => {
      setValue(endValue);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [
    initialValue,
    endValue,
    delayMs
  ]);
  return value;
}

export { useDelayedTransition as default };
//# sourceMappingURL=useDelayedTransition.js.map
